package data.datasource.remote

// External declarations for browser APIs
external interface Document {
    val cookie: String
}

external interface Window {
    var location: Location
}

external interface Location {
    var href: String
}

external val document: Document
external val window: Window

/**
 * Browser-specific implementation of PlatformApi for Kotlin/JS
 */
private class BrowserPlatformApi : PlatformApi {
    
    override fun getCookie(name: String): String? {
        return try {
            val cookies = document.cookie
            println("🍪 PlatformApi: All cookies: '$cookies'")
            println("🔍 PlatformApi: Looking for cookie: '$name'")
            
            val regex = "$name=([^;]+)".toRegex()
            val match = regex.find(cookies)
            val result = match?.groupValues?.get(1)
            
            if (result != null) {
                println("✅ PlatformApi: Found cookie '$name' with value: '${result.take(10)}...'")
            } else {
                println("❌ PlatformApi: Cookie '$name' not found")
                // Also log individual cookies for debugging
                val cookiePairs = cookies.split(";").map { it.trim() }
                println("🔍 PlatformApi: Individual cookies:")
                cookiePairs.forEach { cookie ->
                    println("  - '$cookie'")
                }
            }
            
            result
        } catch (e: Throwable) {
            println("💥 PlatformApi: Error getting cookie '$name': ${e.message}")
            null
        }
    }
    
    override fun redirectTo(url: String) {
        try {
            println("🚀 PlatformApi: Redirecting to: $url")
            window.location.href = url
        } catch (e: Throwable) {
            println("💥 PlatformApi: Failed to redirect: ${e.message}")
        }
    }

    override fun clearCookie(name: String) {
        try {
            println("🗑️ PlatformApi: Clearing cookie: $name")
            // Set cookie with past expiration date to clear it
            js("document.cookie = '$name=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'")
            println("✅ PlatformApi: Cookie $name cleared")
        } catch (e: Throwable) {
            println("💥 PlatformApi: Failed to clear cookie $name: ${e.message}")
        }
    }
}

/**
 * Actual implementation for JS platform
 */
actual fun createPlatformApi(): PlatformApi = BrowserPlatformApi()

// JavaScript inline function declaration
private external fun js(code: String): dynamic
